import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { AclGuard } from '@app/core/guards/acl-guard.service';
import { ComplianceGuard } from '@core/guards/compliance.guard';

export const routes: Routes = [
    {
        path: 'sso/:token',
        loadComponent: () =>
            import('./shared/layout/auth-empty-layout/auth-empty-layout.component').then(
                (c) => c.AuthEmptyLayoutComponent,
            ),
        children: [
            {
                path: '',
                loadComponent: () => import('app/containers/auth/sso/sso.component').then((c) => c.SsoComponent),
            },
        ],
    },
    {
        path: 'mci',
        canActivate: [AuthGuard, AclGuard, ComplianceGuard],
        loadComponent: () =>
            import('./shared/layout/mci-layout/mci-layout.component').then((c) => c.MciLayoutComponent),
        children: [
            {
                path: '',
                loadChildren: () => import('app/containers/mci/mci-routing').then((m) => m.routes),
            },
        ],
    },
    {
        path: 'settings',
        canActivate: [AuthGuard, AclGuard, ComplianceGuard],
        loadComponent: () =>
            import('./shared/layout/mci-layout/mci-layout.component').then((c) => c.MciLayoutComponent),
        children: [
            {
                path: '',
                loadChildren: () => import('app/containers/mci/settings/settings.routing').then((m) => m.routes),
            },
        ],
    },
    {
        path: 'product-use',
        loadComponent: () =>
            import('./shared/layout/auth-empty-layout/auth-empty-layout.component').then(
                (c) => c.AuthEmptyLayoutComponent,
            ),
        children: [
            {
                path: '',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import('app/containers/compliance/compliance.component').then((c) => c.ComplianceComponent),
            },
        ],
    },
    { path: '**', redirectTo: '/product-use', pathMatch: 'full' },
];
